module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "toolbar"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "height": 50,
      "app": "",
      "color": "white",
      "clipped-left": "",
      "elevation": "0"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({
          attrs: {
            "icon": ""
          }
        }, 'div', attrs, false), on), [_c('v-avatar', {
          attrs: {
            "size": "32"
          }
        }, [_c('v-img', {
          attrs: {
            "src": require('@/assets/img/avatar-default.svg')
          }
        })], 1), _vm._v(" "), _c('v-icon', {
          attrs: {
            "color": "#4F4F4F"
          }
        }, [_vm._v("mdi-menu-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.handleLogout
    }
  }, [_c('v-list-item-title', {
    staticClass: "test_cursor"
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31464780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/layout/TheToolbar.vue
// module id = 2262
// module chunks = 1